/**
 * @generated SignedSource<<799cbddd572cacf95e10be7583607a02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserProfileRootQuery$variables = {
  userId: string;
};
export type UserProfileRootQuery$data = {
  readonly user: {
    readonly resourcePath: string;
    readonly followerPrivacy: boolean | null;
    readonly viewerCanFollow: boolean;
    readonly followers: {
      readonly pageInfo: {
        readonly total: number;
      };
    };
    readonly following: {
      readonly pageInfo: {
        readonly total: number;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"Header_user" | "UserFollowButton_user">;
  } | null;
};
export type UserProfileRootQuery = {
  variables: UserProfileRootQuery$variables;
  response: UserProfileRootQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "followerPrivacy",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanFollow",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "followers",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "followers(first:1)"
},
v8 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "following",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "following(first:1)"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserProfileRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserFollowButton_user"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserProfileRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxHeight",
                        "value": 116
                      },
                      {
                        "kind": "Literal",
                        "name": "maxWidth",
                        "value": 116
                      },
                      {
                        "kind": "Literal",
                        "name": "scale",
                        "value": 2
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformedSrc",
                    "storageKey": "transformedSrc(maxHeight:116,maxWidth:116,scale:2)"
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Actor",
            "abstractKey": "__isActor"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "birthDayPrivacy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Province",
                "kind": "LinkedField",
                "name": "province",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortName",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserSportStat",
            "kind": "LinkedField",
            "name": "stats",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gamesPlayed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Sport",
                "kind": "LinkedField",
                "name": "sport",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerIsFollowing",
            "storageKey": null
          },
          (v7/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a2738fbc0eaa4e248246101dd578b79",
    "id": null,
    "metadata": {},
    "name": "UserProfileRootQuery",
    "operationKind": "query",
    "text": "query UserProfileRootQuery(\n  $userId: ID!\n) {\n  user(id: $userId) {\n    ...Header_user\n    ...UserFollowButton_user\n    resourcePath\n    followerPrivacy\n    viewerCanFollow\n    followers(first: 1) {\n      pageInfo {\n        total\n      }\n    }\n    following(first: 1) {\n      pageInfo {\n        total\n      }\n    }\n    id\n  }\n}\n\nfragment Avatar_actor_21H4Gh on Actor {\n  __isActor: __typename\n  name\n  avatar {\n    transformedSrc(maxHeight: 116, maxWidth: 116, scale: 2)\n    id\n  }\n}\n\nfragment Header_user on User {\n  ...Avatar_actor_21H4Gh\n  createdAt\n  birthDayPrivacy\n  displayName\n  profile {\n    age\n    id\n  }\n  city {\n    name\n    province {\n      shortName\n      id\n    }\n    id\n  }\n  stats {\n    gamesPlayed\n    sport {\n      slug\n      id\n    }\n  }\n}\n\nfragment UserFollowButton_user on User {\n  id\n  firstName\n  lastName\n  viewerIsFollowing\n  followers(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d6fec99354501592e4fffefab651c29";

export default node;
